import { memo } from 'react';
import { clsx } from 'clsx';
import type { IconProps } from './types';
import iconStyles from './Icon.module.scss';

const PlayIcon = ({
    iconLabel,
    color,
    circular = false,
}: IconProps & {
    circular?: boolean;
}) => (
    <div
        className={clsx({
            [iconStyles.circleContainer]: circular,
        })}
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.236"
            height="20.45"
            viewBox="0 0 18.236 20.45"
            data-icon={iconLabel}
            color={color}
        >
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2px"
                d="M9.225,0,18.45,16.236H0Z"
                transform="translate(17.236 1) rotate(90)"
            />
        </svg>
    </div>
);

export default memo(PlayIcon);
